import Marquee from "react-fast-marquee";

const AXIOMS = [
  "As Above · So Below",
  "The Emerald Tablet",
  "Picatrix Celestial Timing",
  "Key of Solomon Sigils",
  "Alchemical Transmutation",
  "Folk Witchcraft Restoration",
  "Planetary Hours",
  "Hermetic Axioms",
  "Solve et Coagula",
];

export const ArcaneMarquee = () => (
  <div
    data-testid="arcane-marquee"
    className="border-y border-gold/15 bg-ink2 py-6 overflow-hidden"
  >
    <Marquee speed={28} gradient={false} pauseOnHover>
      {AXIOMS.map((a) => (
        <span
          key={a}
          className="font-serif text-lg tracking-[0.25em] text-gold/60 uppercase mx-10 whitespace-nowrap"
        >
          {a} <span className="text-gold/30 ml-10">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
